import * as React from "react";
import { when } from "mobx";
import { getSnapshot } from "mobx-state-tree";
import { inject, observer } from "mobx-react/native";
import { NavigationActions } from "react-navigation";

import Loading from "@screens/Loading";
@inject("attendantStore", "receiptStore", "printerStore")
@observer
export default class LoadingContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.attendantStore.getData().then(async res => {
      // company settings and the default customer are loaded
      // asynchronously from the local database
      await when(() => this.props.printerStore.companySettings.length > 0);
      await when(
        () => getSnapshot(this.props.receiptStore).defaultCustomer !== "",
      );
      await this.props.receiptStore.currentReceipt(
        this.props.printerStore.companySettings[0].tax,
      );
      setTimeout(() => {
        let routeName = "";
        if (res.result || res.rowsLength > 0) {
          routeName = "Pin";
        } else {
          routeName = "Login";
        }

        const resetAction = NavigationActions.reset({
          index: 0,
          key: null,
          actions: [NavigationActions.navigate({ routeName })],
        });
        this.props.navigation.dispatch(resetAction);
      }, 3000);
    });
  }

  render() {
    return <Loading />;
  }
}
